'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { datadogRum } from '@datadog/browser-rum';
import { initializeDatadog } from '@/lib/datadog';
import { applyRumProductFromPathname } from '@/lib/analytics/rumProduct';
import { subscribePublicSearchGridStoreAfterHydration } from '@/lib/analytics/rumGridStoreSubscriber';

export function DatadogProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      initializeDatadog();
    }
    applyRumProductFromPathname(pathname);

    const url = `${pathname}?${searchParams}`;
    if (datadogRum.getInitConfiguration()) {
      datadogRum.addAction('page_view', { url });
    }
  }, [pathname, searchParams]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    return subscribePublicSearchGridStoreAfterHydration();
  }, []);

  return children;
}
